<template>
  <div class="container page">
    <van-nav-bar class="nav-bar" :title="$t('提现中心')">
      <template #left>
        <van-icon color="#fff" name="arrow-left" @click="$router.replace('/Mine')"/>
      </template>
      <template #right>
        <span class="nav-right" @click="$router.push({path:'/WithdrawRecord'})">{{ $t('历史') }}</span>
      </template>
    </van-nav-bar>
    <div class="main">
      <van-field
          v-model="activeBank"
          @click="showCoinType=true"
          right-icon="arrow"
          readonly
          :label="$t('提现到')"
          :placeholder="$t('请选择{name}',{name: $t('提现到')})"
      />
      <div class="withdrawMoney">
        <span>{{ $t('提现金额') }}</span>
        <div class="money">
          <div class="moneyNumber">
            <span class="moneyType"></span>
            <van-field class="custom-placeholder" :placeholder="$t('请输入{name}',{name: $t('提现金额')})" v-model="withdraw_money" type="number"/>
          </div>
          <span class="all" @click="allMoeny()">{{ $t('全部') }}</span>
        </div>
        <div class="information">
          <div class="description">
            <van-popover v-model="showPopover" trigger="click">
              <div class="popover-body" style="padding: 10px;">
                <p>{{
                    $t('1.单笔限额：最低{min}元，最高{max}元', {min: this.withdrawRole.min, max: this.withdrawRole.max})
                  }}</p>
                <p>{{ $t('2.提现次数：一天最高提现{num}次', {num: this.withdrawRole.num}) }}</p>
                <p>{{ $t('3.到账时间') }}</p></div>
              <template #reference @click="withdrawInfo()">
                <van-icon name="info-o"/>
                {{ $t('限额说明') }}
              </template>
            </van-popover>
          </div>

          <div class="balance">
            <span>{{ $t('余额') }}：</span>
            <span class="number">{{ this.userInfo.money }}</span>
          </div>
        </div>
      </div>
      <van-button class="withdraw_btn" type="default" @click="doWithdraw()">{{ $t('马上提现') }}</van-button>

      <van-popup v-model="showCoinType" :style="{ height: '55%' }" position="bottom" round>
        <div class="card-container">
          <div v-for="(bank, index) in bankInfoList" :key="index" @click="handleSelectBank(bank)" class="bank-card">
            <div class="bank-details">
              <div class="bank-header">
                <div class="account-number">{{ bank.bankName }}</div>
                <img src="@/assets/icon/check.svg" v-if="bank.bankName === activeBank" alt=""/>
              </div>
              <div v-if="bank.account" class="row">
                <div class="label">{{
                    bank.bankName === 'USDT' || bank.bankName === 'USDT' || bank.bankName === 'USDT' ? $t('地址') : $t('银行账户号码')
                  }}
                </div>
                <div class="value">{{ bank.account }}</div>
              </div>
              <div v-if="bank.address" class="row">
                <div class="label">{{ $t('地址') }}</div>
                <div class="value">{{ bank.address }}</div>
              </div>
              <div v-if="bank.owner" class="row">
                <div class="label">{{ $t('姓名') }}</div>
                <div class="value">{{ bank.owner }}</div>
              </div>
            </div>
          </div>
          <div v-if="!bankInfoList.length" class="empty">
            <van-empty :description="$t('暂无数据') + '！'"/>
          </div>
          <van-button v-if="!bankInfoList.length" class="withdraw_btn" type="default" @click="$router.push('/BindCard')">{{ $t('去绑定') }}</van-button>
        </div>

      </van-popup>

    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      showPopover: false,
      showCoinType: false,
      withdraw_money: "",
      bankId: "",
      activeBank: null,
      userInfo: {},
      withdrawRole: {},
      bankInfoList: []
    };
  },
  methods: {
    back() {
      return window.history.back();
    },
    getUserInfo() {
      this.$http({
        method: 'get',
        url: 'user_info'
      }).then(res => {
        if (res.code === 200) {
          this.userInfo = res.data;
          this.name = res.data.name;
        } else if (res.code === 401) {
          this.$toast(res.msg);
        }
      })
    },
    handleSelectBank(bank) {
      this.activeBank = bank.bankName
      this.showCoinType = false;
    },
    getBankList() {
      this.$http({
        method: 'get',
        url: 'userBankList'
      }).then(res => {
        if (res.code === 200) {
          this.bankInfoList = res.data
          if (!this.bankInfoList.length) {
            this.$toast(this.$t('请先绑定银行卡'));
          }
          console.log("=>(Withdraw.vue:136) this.$route.query.from", this.$route.query.from);
          if(this.$route.query.from && this.$route.query.from !== 'BindCard'){
            this.$router.push('/BindCard?from=withdraw')
          }
        } else if (res.code === 401) {
          this.$toast(res.msg);
        }
      })
    },
    getUserWithdrawRole() {
      this.$http({
        method: 'get',
        url: 'user_get_withdraw_role'
      }).then(res => {
        if (res.code === 200) {
          this.withdrawRole = res.data;
        } else if (res.code === 401) {
          this.$toast(res.msg);
        }
      })
    },
    allMoeny() {
      this.withdraw_money = this.userInfo.money;
    },
    doWithdraw() {
      if (!this.activeBank) {
        this.$toast(this.$t("请选择{name}",{name: this.$t('提现到')}));
        return false;
      }
      if (this.withdraw_money <= 0) {
        this.$toast(this.$t("请填写正确的金额"));
        return false;
      } else {
        this.$http({
          method: 'post',
          data: {money: this.withdraw_money,bank_id: this.bankInfoList.find(bank => bank.bankName === this.activeBank).id},
          url: 'user_set_withdraw'
        }).then(res => {
          if (res.code === 200) {
            location.reload()
            this.$toast(res.msg);
            this.getUserInfo();
            this.getUserWithdrawRole();
          } else if (res.code === 401) {
            this.$toast(res.msg);
          }
        })
      }
    },
    withdrawInfo() {
      this.showPopover = true;
    }
  },
  created() {
    if (!localStorage.getItem('token')) {
      this.$router.push({path: '/Login'})
    } else {
      this.getUserInfo();
      this.getUserWithdrawRole();
      this.getBankList();
    }
  }
};
</script>

<style lang='less' scoped>
@import "../../assets/css/base.css";

.van-cell {
  font-size: 35px;
  line-height: 80px;
}

.container p {
  padding: 0 15px;
  margin-top: 15px;
  font-size: 30px;
  color: #dc2037;
}

.container .main {
  display: flex;
  flex-direction: column;
  background-color: #f2f2f5;
  height: calc(100% - 50px);
  position: relative;
}

.container .main .withdrawMoney {
  display: flex;
  flex-direction: column;
  color: #000;
  padding: 0 20px;
  white-space: nowrap;
  font-size: 35px;
  background-color: #fff;
}

.container .main .withdrawMoney span {
  padding: 10px 0;
}

.container .main .withdrawMoney .money {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  border-bottom: 1px solid #f2f2f5;
}

.container .main .withdrawMoney .money .moneyNumber {
  font-size: 50px;
  display: flex;
  flex-direction: row;
}

.container .main .withdrawMoney span {
  padding: 10px 0;
}

.container .main .withdrawMoney .money .all {
  color: #d10404;
}

.container .main .withdrawMoney .money .moneyNumber .van-cell {
  font-size: 50px;
  padding: 0 !important;
}

.container .main .withdrawMoney .information {
  padding-bottom: 30px;
}

.container .main .withdrawMoney .information .description {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  padding: 10px 0;
}

.container .main .withdrawMoney span {
  padding: 10px 0;
}

.container .main .withdrawMoney .information .balance .number {
  color: #d10404;
}

.withdraw_btn {
  margin: 20px 30px 0;
  height: 80px;
  line-height: 1.22667rem;
  border-radius: 50px;
  color: #fff;
  font-size: 30px;
  font-weight: bolder;
  border: none;
  background: linear-gradient(90deg, #e6c3a1, #7e5678);
}


.card-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  color: white;
  padding: 20px;
  .withdraw_btn {
    margin: 20px 100px 0 !important;
    height: 80px;
    line-height: 1.22667rem;
    border-radius: 50px;
    color: #fff;
    font-size: 30px;
    font-weight: bolder;
    border: none;
    width: 100%;
    background: linear-gradient(90deg, #e6c3a1, #7e5678);
  }
}

.bank-card {
  width: 100%;
  background: linear-gradient(135deg, #47350D 0%, #7A5C2E 100%);
  color: white;
  border-radius: 15px;
  padding: 15px 15px 5px;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.5);
  position: relative;
  margin-bottom: 20px;
  font-family: 'Arial', sans-serif;
  overflow: hidden;
}

.bank-card::before {
  content: "";
  position: absolute;
  width: 200%;
  height: 200%;
  background: radial-gradient(circle, rgba(255, 255, 255, 0.1) 25%, transparent 25%);
  background-size: 30px 30px;
  top: -50%;
  left: -50%;
  transform: rotate(45deg);
  opacity: 0.5;
}

.bank-logo {
  font-size: 18px;
  font-weight: bold;
  margin-bottom: 25px;
}

.bank-chip {
  width: 40px;
  height: 30px;
  background-color: #d4af37;
  border-radius: 4px;
  position: absolute;
  top: 50px;
  left: 20px;
}

.bank-details {
  margin-top: 10px;
}
.bank-header {
  display: flex;
  justify-content: space-between;
  img {
    width: 33px;
    height: 33px;
  }
}

.account-number {
  font-size: 35px;
  letter-spacing: 2px;
  margin-bottom: 15px;
  font-weight: bold;
}

.row {
  display: flex;
  justify-content: space-between;
  margin-bottom: 8px;
}

.label {
  color: #fff;
  font-size: 18px;
}

.value {
  font-size: 26px;
}

/* 右上角的按钮样式 */
.action-buttons {
  position: absolute;
  top: 10px;
  right: 10px;
}

.edit-button,
.unbind-button {
  background: rgba(255, 255, 255, 0.2);
  border: none;
  color: white;
  font-size: 12px;
  padding: 5px 10px;
  margin-left: 5px;
  border-radius: 5px;
  cursor: pointer;
}

.edit-button:hover,
.unbind-button:hover {
  background: rgba(255, 255, 255, 0.3);
}

.empty {
  p {
    color: #7d7c7c;
  }
}

::v-deep .custom-placeholder .van-field__control::-webkit-input-placeholder {
  font-size: 30px;
}
</style>
